import { api } from './client';

export const namesApi = {
  suggest: (storyId, { description, kind, kindLabel = null, count = 6 }) =>
    api.post(`/stories/${storyId}/suggest-names`, {
      description,
      kind,
      kind_label: kindLabel,
      count,
    }),
};

export default namesApi;
